

// @mui material components
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";

// Dashboard PRO Material-UI components
import DSButton from "components/DSButton";
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Custom styles for the SidenavCard
import styles from "examples/Sidenav/styles/sidenavCard";

// Dashboard PRO Material-UI context
import { useSoftUIController } from "context";

function SidenavCard() {
  const [controller] = useSoftUIController();
  const { miniSidenav, sidenavColor } = controller;
  const classes = styles({ miniSidenav, sidenavColor });

  return (
    <Card className={classes.card}>
      <CardContent className={classes.card_content}>
        <DSBox customClass={classes.card_iconBox}>
          <Icon className={classes.card_icon} fontSize="default">
            star
          </Icon>
        </DSBox>
        <DSBox>
          <DSTypography variant="h6" textColor="white">
            
          </DSTypography>
          <DSBox mb={1.5} mt={-1}>
            <DSTypography variant="caption" textColor="white" fontWeight="medium">
              Return to Home
            </DSTypography>
          </DSBox>
          <DSButton
            component={Link}
            href="https://www.datanetstudio.com"
            target="_blank"
            rel="noreferrer"
            size="small"
            color="default"
            fullWidth
          >
            Dashboard
          </DSButton>
        </DSBox>
      </CardContent>
    </Card>
  );
}

export default SidenavCard;
